/**
 * 返回所有category等于"community"的节点（仅同级节点，不包含父级和子级）
 * @param data 树形结构数据
 * @returns 所有社区节点数组
 */
export function getCommunities(data: any[]): any[] {
  const communities: any[] = [];

  function traverse(nodes: any[]) {
    nodes.forEach((node) => {
      // 检查当前节点是否为社区
      if (node.category === 'community') {
        // 创建只包含同级属性的副本（排除children和父级关联）
        const { ...communityNode } = node;
        communities.push(communityNode);
      }
      // 继续遍历子节点
      if (node.children) {
        traverse(node.children);
      }
    });
  }

  traverse(data);
  return communities;
}

/**
 * 根据ID查找并返回该节点的直接子节点
 * @param data 树形结构数据
 * @param targetId 要查找的节点ID
 * @returns 子节点数组（如果找不到返回空数组）
 */
export function getChildrenById(data: any[], targetId: string): any[] {
  let found = false;
  let result: any[] = [];

  function traverse(nodes: any[]) {
    if (found) return;

    for (const node of nodes) {
      // 找到目标节点
      if (node.id === targetId) {
        found = true;
        result = node.children ? [...node.children] : [];
        return;
      }

      // 递归搜索子节点
      if (node.children) {
        traverse(node.children);
      }
    }
  }

  traverse(data);
  return result;
}
